<template>
  <div class="mergesuccessDialog">
    <el-dialog :visible.sync="mergeSuccessVisible" center :show-close="false" custom-class="mergesuccess"
      :before-close="handleClose">
      <template slot="title">
        <DialogsHeader :title="bankType === 'memory' ? $t('memoryBankV2.mergememoryBank') : $t('termBankV2.mergeTermBank')" />
      </template>
      <div class="mergesuccessDialog-content">
        {{ $t('assignTaskV2.combineSuccess') }}
      </div>
      <template slot="footer">
        <el-button size="small" @click="handleClose">{{ $t('project.close') }}</el-button>
        <el-button size="small" type="primary" @click="handlerDetail">
          {{ $t('memoryBankV2.gotocheck') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
// 标题组件
import DialogsHeader from '@/common/dialogsHeader';
export default {
  name: "mergesuccessDialog",
  data() {
    return {

    }
  },
  components: { DialogsHeader },
  props: {
    mergeSuccessVisible: {
      type: Boolean,
      required: true
    },
    bankType: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClose() {
      this.$emit("handleClose")
    },
    handlerDetail() {
      this.$emit("handlerDetail")
    },
  }
}
</script>
<style lang="less" scoped>
.mergesuccessDialog {
  /deep/ .mergesuccess {
    width: 359px;
    background: #ffffff;
    box-shadow: 0px 10px 28px 1px rgba(51, 51, 51, 0.18);
    border-radius: 4px 4px 4px 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);

    .el-dialog__header {
      padding: 16px 32px;
    }

    .el-dialog__body {
      padding: 0px;

      .mergesuccessDialog-content {
        width: 100%;
        height: 120px;
        background: url("../images/mergeSuccess.png") no-repeat center center;
        text-align: center;
        line-height: 200px;
        font-size: 14px;
        font-weight: bold;
        color: #303133;
      }
    }

    .el-dialog__footer {
      padding: 10px 32px 32px;
    }
  }
}</style>